/**
 * Analyses changes and converts them to row change.
 * Could be refactored...
 * 
 * @param {any} change
 * @param {any} source
 * @param {any} getIdForRow
 */
export default function (change, source, getIdForRow) {
    if (!change) {
        return undefined;
    }
    const changes = analyseChanges(change, getIdForRow);

    return changes;
}

function analyseChanges(changesReported, getIdForRow) {
    const changes = [];
    for (let change of changesReported) {
        let result = analyseChange(change);
        if (result) {
            changes.push(result);
        }
    }
    const groupedPerRow = groupChangesPerRow(changes);
    const rowChanges = convertToRowChange(groupedPerRow, getIdForRow);

    return rowChanges;
}

function convertToRowChange(changeMap, getIdForRow) {
    const changes = [];

    for (let [row, cellChanges] of changeMap) {
        const id = getIdForRow(row);

        let change = new RowChange(id, row, cellChanges);
        changes.push(change);
    }

    return changes;
}

function groupChangesPerRow(changes) {
    const map = new Map();
    changes.forEach((item) => {
        const row = item.row;

        if (map.has(row)) {
            map.get(row).push(item);
        } else {
            map.set(row, [item]);
        }
    });

    return map;
}

function analyseChange(change) {
    if (!change.isChanged()) {
        return undefined;
    }

    return change;
}

class RowChange {
    changes = [];

    constructor(id, row, changes) {
        this.id = id;
        this.row = row;
        for (const change of changes) {
            this.changes.push(new ColChange(change));
        }
    }

}

class ColChange {
    constructor(c) {
        this.index = c.col;
        this.value = c.newValue;
    }
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/processChange.js